import { ExpressionResolverFn } from "../../core/types";
import { ExpressionResolverError } from "../errors";
import { extractFieldRef } from "../utils/parameterExtractors";

class IsEmptyExpressionError extends ExpressionResolverError {
  constructor(message: string) {
    super(message);
    this.name = "IsEmptyExpressionError";
  }
}

export const isEmptyResolver: ExpressionResolverFn = async (config) => {
  const { templateFieldValueResolver, expression } = config;

  if (!expression.params) {
    throw IsEmptyExpressionError.create("No parameters provided");
  }

  try {
    const comparedValue = extractFieldRef(
      expression,
      templateFieldValueResolver
    );

    return (
      comparedValue === "" ||
      comparedValue === null ||
      comparedValue === undefined
    );
  } catch (error) {
    if (
      error instanceof Error &&
      error.message.includes("Missing fieldValue")
    ) {
      throw IsEmptyExpressionError.create("Missing fieldValue or ref");
    }
    throw IsEmptyExpressionError.create(
      error instanceof Error ? error.message : "Failed to extract fieldValue"
    );
  }
};
